module.exports = {
    bucket: 'img-yimou',
    endpoint: 'oss-cn-hangzhou.aliyuncs.com',
    region: 'oss-cn-hangzhou',
    accessKeyId: 'LTAI5tNhw6PW2LpxH2GHAJm5',
    accessKeySecret: 'AiUrhCMSJSWBOqwTvigWCMZbXnjilm',
};



// WEBPACK FOOTER //
// ./src/utils/ossinfo.js